import {
  axiosDelete,
  axiosGet,
  axiosPatch,
  axiosPost,
  fetchImage,
} from '../axios/axios.config';

export const searchGallery = async (data) => {
  const response = await axiosGet('data/api/types/gallery', data);
  return response;
};

export const createGallery = async (data) => {
  const response = await axiosPost('data/api/types/gallery', data);
  return response;
};

export const getGallery = async (galleryId) => {
  // const response = await axiosGet(`data/api/types/gallery/${galleryId}`);
  const response = await searchGallery({ q: galleryId });
  return response.data?.objects?.[0];
};

export const getGalleryImage = async (galleryId) => {
  const response = await fetchImage(
    `data/api/types/gallery/${galleryId}/avatar`,
    {
      responseType: 'arraybuffer',
    }
  );
  return response;
};

export const updateGallery = async (galleryId, data) => {
  const response = await axiosPatch(
    `data/api/types/gallery/${galleryId}`,
    data
  );
  return response;
};

export const updateGalleryImage = async (galleryId, data) => {
  const response = await axiosPost(`data/api/types/gallery/${galleryId}`, data);
  return response;
};

export const deleteGallery = async (galleryId) => {
  const response = await axiosDelete(`data/api/types/gallery/${galleryId}`);
  return response;
};

export const galleryAnalytics = async (data) => {
  const response = await axiosPost(
    'analytics/api/query/contacts/downloads',
    data
  );
  return response;
};
